import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  wrapper: {
    width: "175%"
  }
}))

export default styles
